import React from "react";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";

const ComingSoon = () => {
  const route = all_routes;
  return (
    <div>
      {/* Page Content */}
      <div className="main-wrapper coming-soon-page">
        <div className="content ellipses">
          <div className="container">
            <section className="d-flex justify-content-center align-items-center">
              <div className="row vph-100 d-flex align-items-center">
                <div className="col-sm-10 col-md-10 col-lg-10 mx-auto">
                  {/* Header */}
                  <header className="text-center">
                  </header>
                  {/* /Header */}
                  <div className="text-img">
                    <h1>Coming Soon</h1>
                  </div>
                  <div className="col-sm-10 col-md-10 col-lg-10 mx-auto text-center">
                    <h3>Great things are coming soon</h3>
                    <p>
                      We are currently woking on new website , We’ll be
                      launching soon
                    </p>
                  </div>
                </div>
              </div>
            </section>
          </div>
          
        </div>
        {/* /Page Content */}
      </div>
    </div>
  );
};

export default ComingSoon;
